import ManageCompaniesCreateController from './controller/ManageCompaniesCreateController.js'
const template = require('./manageCompaniesCreate.component.tpl.pug')

const manageCompaniesCreate = {
  controller: ManageCompaniesCreateController,
  template: template()
}

export default manageCompaniesCreate
